// import React, { useState, useEffect } from 'react';
// import Switch from '@mui/material/Switch';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, CircularProgress } from '@mui/material';
// import { Button } from 'reactstrap';
// import { useMain } from 'src/views/hooks/useMain';
// import { Box } from '@mui/system';
// import TextInputs from 'src/components/inputs/TextInputs';

// const OTPSettings = ({ data, refreshData }) => {
//   const { sendDownloadBtnOtp, verifyDownloadBtnOtp, setShowMessage, branchData } = useMain();

//   const [otpEnabled, setOtpEnabled] = useState(false);
//   const [otp, setOtp] = useState('');
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [otpGenerated, setOtpGenerated] = useState(false);

//   // Sync with props when data changes
//   useEffect(() => {
//     if (branchData) {
//       setOtpEnabled(branchData.hideDownloadButton === true);
//     }
//   }, [branchData]);

//   const handleToggleChange = () => {
//     if (!otpEnabled) {
//       // Turning ON - Generate OTP first
//       handleGenerateOTP();
//     } else {
//       // Turning OFF - Confirmation dialogue
//       setOpenDialogue(true);
//     }
//   };

//   const handleGenerateOTP = async () => {
//     setIsLoading(true);
//     try {
//       const res = await sendDownloadBtnOtp(data._id);

//       if (res.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'OTP generated successfully',
//           messageType: 'success'
//         });
//         setOtpGenerated(true);
//         setOpenDialogue(true);
//       } else {
//         setShowMessage({
//           message: res.message || 'Failed to generate OTP',
//           messageType: 'error'
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something went wrong',
//         messageType: 'error'
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleVerifyOTP = async () => {
//     if (otp === '') {
//       setShowMessage({ message: 'Please enter OTP', messageType: 'error' });
//       return;
//     }
//     if (otp.length !== 6) {
//       setShowMessage({ message: 'OTP must be 6 digits', messageType: 'error' });
//       return;
//     }

//     setIsLoading(true);
//     try {
//       const res = await verifyDownloadBtnOtp(data._id, otp, !otpEnabled);

//       if (res.statusCode === 200) {
//         setShowMessage({
//           message:
//             res.message ||
//             `OTP ${!otpEnabled ? 'verified and enabled' : 'verified and disabled'} successfully`,
//           messageType: 'success'
//         });

//         // Optimistically update toggle immediately
//         setOtpEnabled(!otpEnabled);

//         setOtp('');
//         setOtpGenerated(false);
//         setOpenDialogue(false);

//         // Refresh server data in background (not blocking UI)
//         refreshData(data._id);
//       } else {
//         setShowMessage({
//           message: res.message || 'OTP verification failed',
//           messageType: 'error'
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something went wrong',
//         messageType: 'error'
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCloseDialogue = () => {
//     setOpenDialogue(false);
//     setOtp('');
//     setOtpGenerated(false);
//   };

//   return (
//     <div
//       style={{
//         padding: '20px',
//         backgroundColor: '#FAFAFA',
//         borderRadius: '10px',
//         border: '0.5px solid #CFCFCF',
//         marginTop: '20px'
//       }}
//     >
//       <FormControlLabel
//         control={
//           <Switch
//             checked={otpEnabled}
//             onChange={handleToggleChange}
//             disabled={isLoading}
//           />
//         }
//         label="Turn on/off data download button (Manage billing, Sales analytics)"
//       />

//       <Dialog open={openDialogue} onClose={handleCloseDialogue}>
//         <DialogTitle>
//           {otpGenerated ? 'Enter OTP' : 'Confirm OTP Settings Change'}
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             {otpGenerated
//               ? `An OTP has been sent to your registered email/mobile. Please enter it below to ${
//                   otpEnabled ? 'disable' : 'enable'
//                 } OTP verification.`
//               : `Are you sure you want to turn OTP verification ${
//                   otpEnabled ? 'OFF' : 'ON'
//                 }?`}
//           </DialogContentText>

//           {otpGenerated && (
//             <Box style={{ marginTop: '10px' }}>
//               <Grid container spacing={3}>
//                 <Grid item xs={12}>
//                   <TextInputs
//                     title={'Enter OTP'}
//                     name={'otp'}
//                     value={otp}
//                     handleChange={(e) =>
//                       setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))
//                     }
//                     type={'text'}
//                     disabled={isLoading}
//                     placeholder="Enter 6-digit OTP"
//                   />
//                 </Grid>
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDialogue} disabled={isLoading}>
//             Cancel
//           </Button>
//           <Button
//             onClick={otpGenerated ? handleVerifyOTP : handleGenerateOTP}
//             autoFocus
//             disabled={isLoading || (otpGenerated && (otp === '' || otp.length !== 6))}
//           >
//             {isLoading ? (
//               <CircularProgress size={18} style={{ color: 'white' }} />
//             ) : otpGenerated ? (
//               'Verify OTP'
//             ) : (
//               'Generate OTP'
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default OTPSettings;
import React, { useState, useEffect } from 'react';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Button } from 'reactstrap';
import { useMain } from 'src/views/hooks/useMain';
import { Box } from '@mui/system';
import TextInputs from 'src/components/inputs/TextInputs';

const OTPSettings = ({ data, refreshData }) => {
  // Rename this to whatever function in useMain() calls the
  // downloadBtnOtpGenerator endpoint (POST /:id with { password, status })
  const { updateDownloadButtonVisibility, setShowMessage, branchData } = useMain();

  const [otpEnabled, setOtpEnabled] = useState(false);
  const [password, setPassword] = useState('');
  const [openDialogue, setOpenDialogue] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Sync with branchData, same pattern as MaskingComponent syncing with `data`
  useEffect(() => {
    if (branchData) {
      setOtpEnabled(branchData.hideDownloadButton === true);
    }
  }, [branchData]);

  const handleToggleChange = () => {
    setOpenDialogue(true);
  };

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
    setPassword('');
    setShowPassword(false);
  };

  const handleMaskToggle = async () => {
    if (!password) {
      setShowMessage({ message: 'Please enter login password', messageType: 'error' });
      return;
    }
    setIsSubmitting(true);
    try {
      // status = true means "hide download button" (per backend message logic:
      // "Download buttons are now disabled" when status is true)
      const res = await updateDownloadButtonVisibility(data._id, {
        password,
        status: !otpEnabled,
      });

      if (res.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Successfully updated settings',
          messageType: 'success',
        });
        setOtpEnabled(!otpEnabled);
        setPassword('');
        setShowPassword(false);
        setOpenDialogue(false);
        refreshData(data._id);
      } else {
        setShowMessage({ message: res.message || 'Failed to update settings', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      style={{
        padding: '20px',
        backgroundColor: '#FAFAFA',
        borderRadius: '10px',
        border: '0.5px solid #CFCFCF',
        marginTop: '20px',
      }}
    >
      <FormControlLabel
        control={<Switch checked={otpEnabled} onChange={handleToggleChange} />}
        label="Turn on/off data download button (Manage billing, Sales analytics)"
      />

      {/* <Typography variant="h6" style={{ marginTop: '20px' }}>
        {otpEnabled ? 'Download Buttons Hidden' : 'Download Buttons Visible'}
      </Typography>
      <Typography variant="body1" style={{ marginTop: '10px' }}>
        {otpEnabled
          ? 'Download buttons are currently hidden across billing and sales analytics.'
          : 'Download buttons are currently visible across billing and sales analytics.'}
      </Typography> */}

      <Dialog open={openDialogue} onClose={handleCloseDialogue}>
        <DialogTitle>Confirm Request</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to turn download buttons {otpEnabled ? 'ON' : 'OFF'}?
          </DialogContentText>
          <Box style={{ marginTop: '10px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextInputs
                  title="Login Password"
                  name="password"
                  value={password}
                  handleChange={(e) => setPassword(e.target.value)}
                  type={showPassword ? 'text' : 'password'}
                  disabled={isSubmitting}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                          disabled={isSubmitting}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogue}>Cancel</Button>
          <Button onClick={handleMaskToggle} autoFocus disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default OTPSettings;